module.exports = __webpack_public_path__ + "img/home_banner.399681d7.png";